import { useEffect, useState } from 'react';
import Asynchronousupdate from './type-head-update';
import InputDetail from './detail-input-update';
import '../base/list.css';
import { makeStyles } from 'tss-react/mui';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import DeleteIcon from '@mui/icons-material/Delete';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import Sources from '../../../config/ProfileDetailsData.json'


const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0)
    },
    nested: {
        paddingLeft: theme.spacing(1),
    },
}));
const NewRelation = (props) => {
    const classes = useStyles();
    const [newRelationValue, setNewRelationValue] = useState({Rank:[{value: '1'}], IsPrimary: true,});
    const [primaryHCO, setPrimaryHCO] = useState(true)
    const [value, setValue] = useState(props.Source == 'MNGD-AFF' ? { HCO: '' } : { HCO: ''})
    const [error, setError] = useState(false);
    const [relationSubmit, setSubmitFlag] = useState();
    const [open] = useState(true);
    const [clear, setClear] = useState(false)
    const [showRelationTypeForExtHCO, setShowRelationTypeForExtHCO] = useState(true)
    useEffect(() => {
        setError(props.error)
        if (props.clear) {
            setValue(props.Source == 'MNGD-AFF' ? { HCO: '' } : { HCO: ''});
            setNewRelationValue({Rank:[{value: '1'}], IsPrimary: true});

        }
        setClear(props.clear);
    }, [props.error, props.clear, props.newHCP])

    /**
     * Handle Nested Atrribute change
     * @param {*} newValue 
     * @param {*} Name 
     * @param {*} flag 
     */
    const setNewNestedValue = async (newValue, Name, flag) => {

        let submitted = false;
        let newFlag = {
            ...relationSubmit,
            [Name]: flag,
        };
        if (Name === "Rank") {
          setPrimaryHCO(!primaryHCO);
          if (
            relationSubmit === undefined ||
            (relationSubmit && relationSubmit.HCO === undefined)
          ) {
            newFlag = {
              ...relationSubmit,
              [Name]: flag,
              HCO:
                newRelationValue &&
                newRelationValue.HCO &&
                newRelationValue.HCO._id
                  ? false
                  : true,
            };
          }
        }
        Object.keys(newFlag).forEach((res) => {
          submitted = submitted || newFlag[res];
        });
        setSubmitFlag((oldValue) => {
          return {
            ...oldValue,
            [Name]: flag,
          };
        });

        if (Name == "Rank") {
          await setNewRelationValue({
            ...newRelationValue,
            [Name]: [newValue],
            ["IsPrimary"]: newValue["value"] != "1" ? false : true,
          });
        } else {
          await setNewRelationValue(
            {
              ...newRelationValue,
              [Name]: [newValue],
            },
            submitted
          );
        }

        if (!submitted) {
          if (Name == "Rank") {
            await setNewRelationValue({
              ...newRelationValue,
              [Name]: [newValue],
              ["IsPrimary"]: newValue["value"] != "1" ? false : true,
            });

            props.AddNewRelation(
              {
                ...newRelationValue,
                [Name]: [newValue],
                ["IsPrimary"]: newValue["value"] != "1" ? false : true,
              },
              submitted
            );
          } else {
            props.AddNewRelation(
              {
                ...newRelationValue,
                [Name]: [newValue],
              },
              submitted
            );
          }
        } else {
          props.AddNewRelation(undefined, submitted);
        }
    }

    /**
     * Handle Delete Item
     */
    const deleteNewItem = () => {
        props.AddNewRelation(undefined)
        props.deleteNewItem();
    }

    /**
     * handle overall Flag computation for nested attribute
     * @returns Return overall Flag for nested attribute
     */
    const checkFlag = (hcoValue) => {
        return (
          props.Source == "MNGD-AFF"
            ? hcoValue &&
            hcoValue.HCO &&
            hcoValue.HCO._id 

            : hcoValue &&
            hcoValue.HCO &&
            hcoValue.HCO._id 
        )
          ? true
          : false;
    }
    /**
     * Handle Add New  relation
     * @param {*} newValue 
     * @param {*} flag 
     */
    const addRelation = (newValue, flag, type) => {
      if (type === undefined){

        if (newValue._source !== '') {
          
            if (newValue._source.link !== undefined) {
              setShowRelationTypeForExtHCO(false)
                setValue(props.newHCP ?
                    {
                        HCO: newValue._source.label,
                        AddressLine1: 'text',
                        City: 'text',
                        Zip: 'text',
                        StateProvince: 'text',
                        Country: '',
                        ClassificationCode: '', 
                    } : props?.Source === 'VNDR-VOD' ?
                    {
                        HCO: newValue._source.label,
                        AddressLine1: 'text',
                        City: 'text',
                        Zip: 'text',
                        StateProvince: '',
                        Country: '',
                        ClassificationCode: '',
                        RelationTypeCode: ''
                    }: {
                        HCO: newValue._source.label,
                        AddressLine1: 'text',
                        City: 'text',
                        Zip: 'text',
                        StateProvince: 'text',
                        Country: '',
                        ClassificationCode: '',
                    })
                setNewRelationValue({
                    ...newRelationValue,
                    HCO: [{
                        value: newValue._source.label
                    }]
                })
                props.AddNewRelation(undefined, true);
                setSubmitFlag((oldValue) => {
                    return props.Source == 'MNGD-AFF' ? {
                        ...oldValue,
                        HCO: false,
                        AddressLine1: true,
                        City: true,
                        Zip: true,
                        StateProvince: true,
                        Country: true,
                        ClassificationCode: true
                    } : {
                        ...oldValue,
                        HCO: false,
                        AddressLine1: true,
                        City: true,
                        Zip: true,
                        StateProvince: true,
                        Country: true,
                        ClassificationCode: true,
                        RelationTypeCode: props.Source == 'VNDR-VOD' ? true : false
                    }
                })
            } else {    
              setShowRelationTypeForExtHCO(true)            
                setValue(props.Source == 'MNGD-AFF'? { HCO: '' } : { HCO: ''}) 

                if(newRelationValue && newRelationValue['IsPrimary'] && newValue &&
                    newValue._source &&
                    newValue._source.Source &&
                    newValue._source.Source[0].value == "VNDR-CGDM" ){
                    setNewRelationValue({
                        ...newRelationValue,
                        HCO: newValue,
                        ['Rank']:[{value: 99}],
                        ['IsPrimary'] : false
                    })                                       
                }else{
                    setNewRelationValue({
                        ...newRelationValue,
                        HCO: newValue                      
                    })
                }
                
                if (props.newHCP) {
                    props.AddNewRelation({
                      ...newRelationValue,
                        HCO: newValue                      
                    }, flag)
                } else {
                    props.Source == "MNGD-AFF"
                      ? checkFlag({ HCO: newValue }) &&
                        props.AddNewRelation(
                          {
                            ...newRelationValue,
                            HCO: newValue
                          },
                          false
                        )
                      : checkFlag({HCO: newValue}) &&
                        props.AddNewRelation(
                          {
                            ...newRelationValue,
                            HCO: newValue
                          },
                          false
                        );
                }

            }
        } else {
            setShowRelationTypeForExtHCO(false)
            setValue(
                props.Source == 'MNGD-AFF' ? { HCO: '' } : { HCO: ''}
            );
            props.AddNewRelation(undefined, true)

        }
      }

      if (type !== undefined){
        setNewRelationValue({
                        ...newRelationValue,
                        relationTypeCode: newValue                 
                    })
        props.AddNewRelation({
                        ...newRelationValue,
                        relationTypeCode: newValue                 
                    })
      }
    }
    return (
        <div>
            <List
                component="nav"
                aria-labelledby="nested-list-subheader"
                className={classes.root}
            >
                {props.newHCP === undefined &&
                    <ListItem className={open ? ' bg-muted' : ''}>
                        <ListItemText id="list-text" primary={"New"} />
                        <DeleteIcon className='pointer text-primary' onClick={deleteNewItem} />
                    </ListItem>
                }
                <Collapse in={open} timeout="auto" unmountOnExit>
                    <List component="div" className="bg-grey" >
                        <ListItem className={classes.nested}>
                            <ListItemText primary={
                                Object.keys(value).map((label, i) => {
                                    let keysValue = label;
                                    let propertyValue = value[label];
                                    if (label.length > 3) {
                                        label = label.replace(/([A-Z])/g, ' $1')
                                            .replace(/^./, (str) => str.toUpperCase())
                                    }
                                    return (
                                        <div key={i}>
                                            {keysValue === 'HCO' &&
                                                <div key={i} className='mt-2'>
                                                    <span className="text-muted mb-0  mt-2">{label + ' * '}</span>
                                                    <span><Asynchronousupdate clear={clear} error={error} iqviaEnnable={!(Sources?.VENDOR_MANAGED_SOURCES?.includes(props.Source) || Sources.OPEN_DATA_SOURCES.includes(props.Source))} country={props.country} Source={props.Source} addRelation={(value, flag) => { addRelation(value, flag) }} searchHCOPayload= {props.searchHCOPayload} hcoQuery={props.hcoQuery} /></span>
                                                </div>
                                            }

                                            {keysValue == 'Rank' || keysValue === 'HCO' &&
                                                <FormControlLabel
                                          label={
                                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                              <span>Primary Affiliation</span>
                                              <Tooltip
                                                disableFocusListener
                                                title="Checking this option will add this HCO as the Primary workplace for the HCP. This will move the previous primary workplace to a lower rank if approved."
                                                id="tooltip"
                                              >
                                                <InfoOutlinedIcon
                                                  className="ms-1"
                                                  style={{ fontSize: 16, cursor: 'pointer', marginLeft: 4 }}
                                                />
                                              </Tooltip>
                                            </div>
                                          }                                       
                                                control={<Checkbox checked={primaryHCO} disabled = {newRelationValue == undefined ||  !newRelationValue.HCO || newRelationValue.HCO.length == 0} onChange={()=>setNewNestedValue(!primaryHCO ? {value: '1'} : {value: '99'}  , 'Rank', false) } />}
                                              />                                        
                                            }
                                            
                                            {keysValue === 'HCO' && showRelationTypeForExtHCO && props.showRelationType &&
                                              <div>
                                              <span className="text-muted mb-0  mt-2" id="list-text">{'Relation Type Code' + ' * '}</span>
                                              <InputDetail
                                              error={error}
                                              date={propertyValue === 'date'}
                                              type={'RelationTypeCode'}
                                              label={'Relation Type Code'} value={''}
                                              updatedValue={(value, flag) => { addRelation(value, flag, 'relationType') }} 
                                              newValue={props.newValue}
                                              entity = {'HCO'}
                                              source = {props?.Source} />
                                              </div>
                                            }
                                            {keysValue !== 'HCO' && keysValue != 'Rank'  && 
                                                <div key={i} className={'mt-2'}>
                                                    <span className="text-muted mb-0  mt-2" id="list-text">{label + ' * '}</span>

                                                      <InputDetail
                                                        error={error}
                                                        date={propertyValue === 'date'}
                                                        type={propertyValue}
                                                        label={label} value={''}
                                                        updatedValue={(newValue, flag) => { setNewNestedValue(newValue, keysValue, flag) }} 
                                                        newValue={props.newValue}
                                                        entity = {'HCO'}
                                                        isRelation = {true}
                                                        source = {props?.Source} />

                                                </div>
                                            }
                                        </div>
                                    )
                                })
                            } />

                        </ListItem>
                    </List>
                </Collapse>
            </List>

        </div>
    )
}

export default NewRelation;